import React from 'react';
import AdvertisingBanner from '../../Advertising/AdvertisingBanner';
import MaintenanceBanner from '../../Maintenance/MaintenanceBanner';
import styles from '../../../../../pages/Home/Home.module.scss';
import useHomeStore from '../../../../../store/homeStore';
import { useNotificationStore } from '../../../../../store/notificationStore';

export const BannersContainer: React.FC = () => {
  const notifications = useNotificationStore((state) => state.notifications);
  const showMaintenanceBanner = useHomeStore(
    (state) => state.showMaintenanceBanner
  );

  return (
    <div className={styles.bannerContainer}>
      {notifications.length > 0 && <MaintenanceBanner />}
      {showMaintenanceBanner !== 'true' && <AdvertisingBanner />}
    </div>
  );
};
